import { Switch, Button, Form } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { forwardRef, useImperativeHandle } from 'react';

const BranchForm = forwardRef(function BranchForm(
  { formValues, onSubmit, loading },
  ref
) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    values: formValues,
  });

  useImperativeHandle(
    ref,
    () => ({
      reset: reset
    }),
    [reset]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <label>
          Address <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          {...register('address', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.address && <p>Please enter address</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Contact Number <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="number"
          {...register('contactNumber', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.contactNumber && <p>Please enter contact number</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Zip Code <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          {...register('zipcode', {
            required: 'Please enter Zip Code!',
          })}
        />
        <small style={{ color: 'red' }}>{errors.zipcode?.message}</small>
      </div>
      <div className="form-group">
        <label>
          Status <span className="login-danger">*</span>
        </label>
        <Controller
          name="status"
          control={control}
          defaultValue={false}
          render={({ field }) => {
            field.checked = field.value;
            return <Switch {...field} className="ms-2" />;
          }}
        />
      </div>
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
    </form>
  );
});
BranchForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
};
export default BranchForm;
